import type { AsyncThunkApiConfig } from '@/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

type ChangePasswordData = uui.domain.actions.rpc.user.ChangePasswordAction['data']

export const changePassword = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  ChangePasswordData,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/change', async (data, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/user/changePassword', {
      type: 'rpc/user/changePassword',
      category: 'rpc',
      data,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        error: result,
        message: result.errorMessage,
      })
    }
  } catch (error) {
    return thunkApi.rejectWithValue({
      error,
      type: 'unknown',
      message: 'Failed to change password',
    })
  }
})
